import React from 'react'

import ActionMenu from './ActionMenu'

function generateHeaderColumns() {
  const headerColumns = [
    { field: 'orgName', headerName: 'Company', width: 100 },
    {
      field: 'uen',
      headerName: 'UEN'
    },
    {
      field: 'orgId',
      headerName: 'Account No.'
    },
    {
      field: 'billNo',
      headerName: 'Invoice No.'
    },
    {
      field: 'transactionNumber', //need to change this to sim status
      headerName: 'SIM Status'
    },
    {
      field: 'status',
      headerName: 'Payment Status'
    },
    {
      field: 'billingDate', //need to get payment date
      headerName: 'Payment Date'
    },
    {
      field: 'billPeriod',
      headerName: 'Updated'
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: () => {
        return <ActionMenu />
      }
    }
  ]

  return headerColumns
}

export default generateHeaderColumns
